import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const currentUserStore = atomWithStorage('currentUser', '');
export const jwtStore = atomWithStorage('jwt', '');
export const profileStore = atomWithStorage('profile', '');
export const isEmployeeStore = atomWithStorage('isEmployee', false);



export const currentPageStore = atom('/');

// Documenti in attesa di firma del dipendente (badge menu e banner home)
export const firmePendingStore = atom(0);
